"use strict";
/* tslint:disable */
var load_themed_styles_1 = require('@microsoft/load-themed-styles');
load_themed_styles_1.loadStyles([{ "rawString": ".ms-PickerPersona-Container{display:inline-block}.ms-Picker-MenuItem.ms-result-content{display:table-row}.ms-Picker-MenuItem.ms-result-content .ms-result-item{display:table-cell;vertical-align:bottom}.ms-PeoplePicker-Persona{width:180px}.ms-PeoplePicker .ms-BasePicker-text{min-height:40px}" }]);
/* tslint:enable */

//# sourceMappingURL=PeoplePicker.scss.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/pickers/PeoplePicker/PeoplePicker.scss.js
 ** module id = 225
 ** module chunks = 0
 **/